import React, { lazy, Suspense } from "react";
import SubPageLoading from "views/pages/SubPageLoading";
import useMobile from "views/components/Editor/mobile/useMobile";
import { MOBILE_EDITOR_ENABLED } from "lib/constants";
const EditorContainer = lazy(() => import("./EditorContainer"));

export const EditorContainerLazy = props => {
  const isMobileViewport = useMobile();
  const isMobile = MOBILE_EDITOR_ENABLED && isMobileViewport;

  return (
    <Suspense fallback={<SubPageLoading height={"100vh"} />}>
      <EditorContainer {...props} isMobile={isMobile} />
    </Suspense>
  );
};
EditorContainerLazy.displayName = "EditorContainer";

export default EditorContainerLazy;
